<template>
	<div class="lg:ts-col-span-7 ts-p-6 ts-bg-slate-50/30 dark:ts-bg-slate-900/10">
		<div class="ts-flex ts-items-center ts-justify-between ts-mb-6">
			<div>
				<h2 class="ts-font-semibold ts-text-slate-700 dark:ts-text-slate-200 ts-flex ts-items-center ts-gap-2">
					<span class="material-icons ts-text-sm">payments</span>
					{{ $t('invoiceAdjustment.paymentMethods') }} <span class="ts-text-red-600">*</span>
				</h2>
				<small v-if="errors.has('received_payment')" class="ts-text-red-500">{{ errors.first('received_payment')
					}}</small>
			</div>
			<div
				class="ts-flex ts-items-center ts-gap-2 ts-px-3 ts-py-1 ts-bg-white dark:ts-bg-slate-800 ts-rounded-lg ts-border ts-border-slate-200 dark:ts-border-slate-700">
				<span class="text-10 ts-font-bold ts-text-slate-400 ts-uppercase ts-tracking-tighter">{{
					$t('invoiceAdjustment.fxRate') }}</span>
				<span class="ts-text-xs ts-font-bold ts-text-primary ts-text-blue-400" v-for="exchange in exchangeRates">
					{{ exchange.currency_code }} : {{ exchange.exchange_rate }}
				</span>
			</div>
		</div>
		<div class="ts-grid ts-grid-cols-1 md:ts-grid-cols-3 ts-gap-4 ts-mb-6">
			<div v-for="(payment, id) in model.received_payment" :key="id"
				class="ts-border ts-border-dashed ts-p-2 ts-rounded">
				<div class="ts-flex ts-justify-between ts-items-center">
					<div style="width: fit-content;"
						class="ts-bg-blue-100 ts-text-blue-500 ts-rounded-lg ts-px-4 ts-pt-1 ts-font-semibold">
						{{ findPaymentNameById(id) }}
					</div>
					<button @click="removePaymentMethod(id)"
						class="ts-h-4 ts-w-4 ts-rounded-full ts-justify-center ts-bg-gray-200 hover:ts-bg-red-500 hover:ts-text-white ts-transform ts-transition-all ts-duration-150">x</button>
				</div>
				<div class="ts-whitespace-no-wrap ts-mt-2">
					<a-radio v-for="(c, index) in currencies" :key="index" :checked="currencyCheck(id, c.currency_id)"
						@change="e => onCurrencyChange(e, c, { id, payment })">
						{{ c.currency_code }}
					</a-radio>
				</div>
				<div v-if="parseInt(id) !== 1" class="ts-grid ts-grid-cols-2 ts-gap-2 ts-mt-2">
					<div>
						<a-select v-model="payment.bank_id" :options="bankOption" :placeholder="$t('invoice.selecteBank')"
							class="ts-w-full" @change="onBankChange(payment)">
						</a-select>
						<div v-if="errors.has(`received_payment.${id}.bank_id`)" class="ts-text-red-500">
							{{ errors.first(`received_payment.${id}.bank_id`) }}
						</div>
					</div>
					<div>
						<a-select v-model="payment.account_id" :options="accountById(payment.bank_id)"
							:placeholder="$t('invoice.selecteAccount')" class="ts-w-full"></a-select>
						<div v-if="errors.has(`received_payment.${id}.account_id`)" class="ts-text-red-500">
							{{ errors.first(`received_payment.${id}.account_id`) }}
						</div>
					</div>
				</div>
				<!-- value input  -->
				<div>
					<div v-for="(p, pindex) in payment.payments" class="ts-py-2 ts-flex ts-items-center ts-space-x-2">
						<div class="ts-space-y-1 ts-w-full">
							<a-input type="number" step="any" v-model.number="p.amount_original"
								:prefix="currencyById(p.currency_original_id).currency_symbol" class="ts-w-full"
								:ref="`input_${id}_${p.currency_original_id}`" @input="paymentInputChange(id, p)" />
							<div v-if="errors.has(`received_payment.${id}.payments.${pindex}.amount_original`)"
								class="ts-text-red-500">
								{{ errors.first(`received_payment.${id}.payments.${pindex}.amount_original`) }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="ts-col-span-3 ts-p-6 ts-border ts-border-dashed ts-rounded-md ts-border-slate-300 dark:ts-border-slate-600 ts-bg-slate-50/50 dark:ts-bg-slate-800/30"
				v-if="!hasReceivePayment">
				<div class="ts-text-center ts-space-y-2">
					<span class="material-icons ts-text-slate-400 ts-text-4xl">payments</span>
					<p class="ts-text-sm ts-text-slate-500 dark:ts-text-slate-400">{{ $t('invoiceAdjustment.noPaymentMethod')
					}}</p>
					<p class="ts-text-xs ts-text-slate-400 dark:ts-text-slate-500">
						{{ $t('invoiceAdjustment.clickAddPaymentMethod') }}
					</p>
				</div>
			</div>
		</div>
		<div
			class=" md:ts-flex-row ts-gap-4 ts-items-start md:ts-items-center ts-justify-between ts-pt-4 ts-border-t ts-border-slate-100 ts-border-slate-700">
			<div class=" ts-grid ts-grid-cols-2 ts-gap-2">
				<a-dropdown placement="bottomCenter">
					<button class="ts-bg-blue-200 ts-text-blue-500 ts-rounded-md ts-px-3 ts-py-2 ts-w-full ts-gap-2 hover:ts-bg-blue-300 hover:ts-text-white ts-duration-150 focus:ts-outline-none ts-flex ts-items-center
											ts-transition-all ts-justify-center">
						<span class="material-icons ts-text-sm">add</span>
						<span class="ts-mt-1">{{ $t('invoiceAdjustment.morePaymentMethod') }}</span>
					</button>
					<a-menu slot="overlay">
						<a-menu-item v-for="(p, index) in paymentMethodsList" :key="index" @click="handleAddPaymentMethod(p.id)">{{
							p.label }}</a-menu-item>
					</a-menu>
				</a-dropdown>
				<div class="ts-text-right ts-w-full ts-space-y-1">
					<h1 class="ts-font-bold ts-uppercase ts-text-gray-500">{{ $t('invoiceAdjustment.totalPaid') }} ({{
						defaultCurrency ? defaultCurrency.currency_code : '' }})
					</h1>

					<h1 class="ts-font-bold ts-uppercase ts-text-gray-700">

						{{ defaultCurrency ? defaultCurrency.currency_symbol : '' }} {{ formatNumber(model.adj_amount) }}
					</h1>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { Errors } from 'form-backend-validation';
import { sumBy } from 'lodash';
export default {
	name: "PaymentMethods",
	props: {
		value: {
			type: Object,
			default: () => ({})
		},
		errors: {
			default: () => new Errors()
		}
	},
	data() {
		return {
			model: {}
		}
	},
	computed: {
		...mapState('invoiceAjustment', ['exchangeRates', 'currencies', 'paymentMethods', 'banks']),
		hasReceivePayment() {
			return Object.keys(this.model.received_payment).length
		},
		defaultCurrency() {
			return this.currencies.find(c => c.is_default)
		},
		findPaymentNameById: vm => (id) => {
			const findPayment = vm.paymentMethods.find(p => p.id == id)
			if (findPayment) {
				return findPayment.label
			}
			return ''
		},
		currencyCheck: vm => (id, currencyId) => {
			const itemPayment = vm.model.received_payment[id]
			if (itemPayment.payments) {
				return itemPayment.payments.find(ip => ip.currency_original_id == currencyId) !== undefined
			}
			return false;
		},
		findExchangeRateById: vm => id => {
			return vm.exchangeRates.find(ex => ex.target_currency_id === id)
		},
		accountById: vm => (id) => {
			const findBank = vm.banks.find(b => b.bank_id === id)
			if (findBank) {
				return findBank.bank_accounts.map(el => ({
					value: el.account_id,
					label: `${el.account_name}`
				}))
			}
		},
		paymentMethodsList() {
			return this.paymentMethods.filter(p => !Object.keys(this.model.received_payment).map(Number).includes(p.id))
		},
		bankOption() {
			return this.banks.map((el) => ({
				value: el.bank_id,
				label: el.bank_name
			}))
		},
		currencyById: vm => (id) => {
			const curr = vm.currencies.find(c => c.currency_id === id)
			if (curr) {
				return curr
			}
			return undefined
		},
		formatNumber: () => (number) => {
			return new Intl.NumberFormat().format(number)
		}
	},
	created() {
		this.model = this.value
	},
	methods: {
		handleAddPaymentMethod(id) {
			// Input validation
			if (!id) {
				throw new Error('Payment method ID is required');
			}

			if (!this.defaultCurrency) {
				this.$toasted.error('Please set default currency first!')
				return
			}

			// Initialize received_payment if it doesn't exist
			if (!this.model.received_payment) {
				this.model.received_payment = {};
			}

			// Use spread operator for cleaner object assignment
			this.model.received_payment = {
				...this.model.received_payment,
				[id]: {
					bank_id: undefined,
					account_id: undefined,
					payments: [
						{
							amount_original: undefined,
							currency_original_id: this.defaultCurrency.currency_id,
							base_currency: this.defaultCurrency.currency_id,
							rate_to_base: 1
						}
					]
				}
			};
			this.focusInputElement(id, this.defaultCurrency.currency_id)
		},
		onCurrencyChange(event, currency, { id, payment }) {
			const isChecked = event.target.checked
			const existingPayment = payment.payments[0]
			const exchange = this.findExchangeRateById(currency.currency_id)
			if (currency.currency_id !== this.defaultCurrency.currency_id && exchange === undefined) {
				this.$toasted.error(`Please set up exchange rate for ${currency.currency_code} first!`)
				return
			}

			if (!existingPayment && isChecked) {
				payment.payments.push({
					amount_original: undefined,
					currency_original_id: currency.currency_id,
					base_currency: this.defaultCurrency.currency_id,
					rate_to_base: currency.currency_id !== this.defaultCurrency.currency_id ? exchange.rate_to_default : 1
				})
				this.focusInputElement(id, currency.currency_id)
			}

			if (existingPayment && !isChecked) {
				payment.payments = []
				this.paymentReceiveInput()
			}

			if (existingPayment && isChecked) {
				existingPayment.amount_original = undefined,
					existingPayment.currency_original_id = currency.currency_id,
					existingPayment.base_currency = this.defaultCurrency.currency_id,
					existingPayment.rate_to_base = currency.currency_id !== this.defaultCurrency.currency_id ? exchange.rate_to_default : 1
			}
			this.clearOtherCurrencyInput(id, payment)
		},
		clearOtherCurrencyInput(methodId, payment) {
			if (methodId == 1) {
				if (Object.keys(this.model.received_payment).length > 0) {
					Object.keys(this.model.received_payment).forEach(method => {
						const payment = this.model.received_payment[method]
						if (payment) {
							payment.payments.forEach(el => {
								el.amount_original = undefined
							})
						}
					})
				}
			}
			this.focusInputElement(methodId, this.defaultCurrency.currency_id)
		},
		focusInputElement(id, currency_id) {
			this.$nextTick(() => {
				const refKey = `input_${id}_${currency_id}`
				const inputElement = this.$refs[refKey]
				if (inputElement) {
					if (Array.isArray(inputElement)) {
						if (inputElement.length) {
							inputElement[0].focus()
						}
					}
				}
			})
		},
		onBankChange(payment) {
			payment.account_id = undefined
			const findBank = this.banks.find(b => b.value === payment.bank_id)
			if (findBank) {
				const account = findBank.accounts
				if (account.length === 1) {
					payment.account_id = account[0].account_id
				}
			}
		},
		paymentReceiveInput() {
			const paymentReceive = Object.values(this.model.received_payment)
			const payment = paymentReceive.flatMap(el => el.payments)
			if (payment) {
				const amount = sumBy(payment, (o) => (o.amount_original || 0) * o.rate_to_base)
				this.model.adj_amount = amount
			} else {
				this.model.adj_amount = 0
			}

		},
		removePaymentMethod(id) {
			if (this.$delete) {
				this.$delete(this.model.received_payment, id);
			} else {
				// Fallback: Replace entire object to trigger reactivity
				const { [id]: removed, ...remaining } = this.model.received_payment;
				this.model.received_payment = remaining;
			}

			this.paymentReceiveInput()
		},
		paymentInputChange(id, payment) {
			if (id == 1 && payment.currency_original_id === this.defaultCurrency.currency_id) {
				const cashPayment = this.model.received_payment[id]
				if (cashPayment) {
					const defaultInput = cashPayment.payments.find(c => c.currency_original_id === this.defaultCurrency.currency_id)
					if (defaultInput) {
						const anotherCurrency = cashPayment.payments
							.filter(c => c.currency_original_id !== this.defaultCurrency.currency_id)

						const amount = (this.model.total_amount - this.model.discounted_amount - defaultInput.amount_original) / anotherCurrency.length

						if (anotherCurrency.length) {
							anotherCurrency.forEach(c => {
								c.amount_original = round(amount * (1 / c.rate_to_base), 2)
							})
						}
					}
				}
			}

			this.$nextTick(() => this.paymentReceiveInput())
		},
	}
}
</script>
